import React from 'react';

import Header from '..';
import Box, { BoxProps } from '../../../../Components/UI/Box';
import styles from '../styles.css';

const ProjectsHeader: React.FC<BoxProps> = ({ ...rest }) => {
  const projectName = 'Project';

  return (
    <>
      <Header {...rest}>
        <Box className={styles['title-wrapper']}>
          <Box className={styles['title']}>
            <Box element="h1" display="flex" alignItems="center">
              <span className={styles['title-text']} title={projectName}>
                {projectName}
              </span>
            </Box>
          </Box>
        </Box>
      </Header>
    </>
  );
};

export default ProjectsHeader;
